import { render, staticRenderFns } from "./HistoryData.vue?vue&type=template&id=0ca90420&scoped=true&"
import script from "./HistoryData.vue?vue&type=script&lang=js&"
export * from "./HistoryData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca90420",
  null
  
)

export default component.exports